module.exports = __webpack_public_path__ + "static/img/transport.bfbb3ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/transport.jpg
// module id = 7M5s
// module chunks = 1